import { FEATURE_NAME } from './consts';

export const CREATE_MERCHANT = `${FEATURE_NAME}/CREATE_MERCHANT`;
